import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Helmet } from "react-helmet-async";
import { Loader2, Lock } from "lucide-react";
import { Btn } from "@/components/Btn";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  const input = "w-full bg-white border-2 border-charcoal rounded-2xl px-4 py-3 font-body focus:outline-none focus:ring-4 focus:ring-sunny/50";
  return (
    <div className="min-h-screen bg-charcoal flex items-center justify-center px-4">
      <Helmet><title>Admin Login</title><meta name="robots" content="noindex, nofollow" /></Helmet>
      <form onSubmit={submit} className="w-full max-w-sm bg-white border-2 border-charcoal rounded-[2rem] shadow-brutlg p-8" data-testid="admin-login-form">
        <div className="w-14 h-14 rounded-2xl border-2 border-charcoal bg-coral text-cream flex items-center justify-center mb-5"><Lock className="w-7 h-7" /></div>
        <h1 className="font-heading font-bold text-3xl">Skedaddle Admin</h1>
        <p className="font-body text-charcoal/60 text-sm mb-6">Private quote tool and leads.</p>
        <label className="font-heading font-semibold text-sm">Email</label>
        <input className={input} type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
        <label className="font-heading font-semibold text-sm mt-4 block">Password</label>
        <input className={input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
        <Btn type="submit" variant="primary" className="w-full mt-6" disabled={busy} data-testid="admin-login-btn">{busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "Log in"}</Btn>
      </form>
    </div>
  );
}
